import { useEffect } from "react";

export function useHeaderDynamicStyles(
  headPrimaryColor,
  headColorSecond,
  mainHeaderbg,
  headColor,
  colorBorderExpBtnExcel
) {
  useEffect(() => {
    // console.log('test');
    document.documentElement.style.setProperty(
      "--headPrimaryColor",
      headPrimaryColor
    );
    document.documentElement.style.setProperty(
      "--headColorSecond",
      headColorSecond
    );
    document.documentElement.style.setProperty("--mainHeaderbg", mainHeaderbg);
    document.documentElement.style.setProperty("--headColor", headColor);
    document.documentElement.style.setProperty(
      "--colorBorderExpBtnExcel",
      colorBorderExpBtnExcel
    );
  }, [
    headPrimaryColor,
    headColorSecond,
    mainHeaderbg,
    headColor,
    colorBorderExpBtnExcel,
  ]);
}
